import template from './add-activity-extension.html'

export let addActivityExtension = {
  bindings: {
    disable: '<'
  },
  template: template,
  controllerAs: 'vm',
  controller: ['$stateParams', '$mdDialog', 'Validations', 'GlobalConfig', 'Ramda', 'ReviewSrv', 'Util', 'WorkPlanModalSrv',
    function addActivityExtensionCtrl ($stateParams, $mdDialog, Validations, GlobalConfig, Ramda, ReviewSrv, Util, WorkPlanModalSrv) {
    const curry = Ramda.curry
    const confirm = Util.confirm('¡creacion de actividad exitosa!', 'La actividad')
    const {
      isInternalProjectsFormulationType,
      isExtensionProjectsType,
      isVisibilityType,
      isConsultancyType,
      isShortCoursesType    
    } = Validations

    const addActivityExtension = (activity) => {
      services({activityTypeId: Number(activity)})
    }

    const services = curry((confirm, activity) => {
      switch (true) {
        case isInternalProjectsFormulationType(activity):
          console.log(activity)        
          WorkPlanModalSrv.addProjectFormulation()
          return 'Formulación de propuesta'
        case isExtensionProjectsType(activity): 
        // console.log("aqui")     
          WorkPlanModalSrv.addProjectExtension()        
          return 'Proyecto de extensión'
        case isVisibilityType(activity):        
          WorkPlanModalSrv.addVisibility()
          return 'Visibilidad'
        case isConsultancyType(activity):        
          WorkPlanModalSrv.addCounselingAndConsultancy()
          return 'Consultoría y asesoría'
        case isShortCoursesType(activity):        
          WorkPlanModalSrv.addEducation()
          return 'Educación continuada'    
      }
    })(confirm)

    angular.extend(this, {
      activityTypes: [
        {name: 'Formulación de propuesta', id: GlobalConfig.activityTypeId.internalProjectsFormulation},
        {name: 'Proyecto de extensión', id: GlobalConfig.activityTypeId.extensionProjects},
        {name: 'Visibilidad', id: GlobalConfig.activityTypeId.visibility},
        {name: 'Consultoría y asesoría', id: GlobalConfig.activityTypeId.consultancy},
        {name: 'Educación continuada', id: GlobalConfig.activityTypeId.shortCourses},      
      ],
      activity: null,
      addActivityExtension: addActivityExtension
    })

  }
]}



// WEBPACK FOOTER //
// ./src/app/u-faculty/components/activities-review/header/add-activity-extension.js